import { NoopType } from 'types/global';
import { IconWrapper } from 'modules/ui/wrappers/IconWrapper';
import { ColorVarsEnum } from 'enums/ColorVarsEnum';
import { AddCircleIcon } from 'assets/icons/withContainer';
import React from 'react';
import { PickerItemWrapper } from 'modules/ui/buttons/AddColorButton/styles';

interface AddColorButtonProps {
  onAdd: NoopType;
}

export const AddColorButton = ({ onAdd }: AddColorButtonProps) => (
  <PickerItemWrapper onClick={onAdd}>
    <IconWrapper
      hoverColorVar={ColorVarsEnum.Level_3}
      colorVar={ColorVarsEnum.Level_3}
      iconWidth="30px"
      iconHeight="30px"
      Icon={AddCircleIcon}
    />
  </PickerItemWrapper>
);
